import { render } from "./MenuLinkItem.vue?vue&type=template&id=6f508e10&scoped=true"
import script from "./MenuLinkItem.vue?vue&type=script&lang=js"
export * from "./MenuLinkItem.vue?vue&type=script&lang=js"

import "./MenuLinkItem.vue?vue&type=style&index=0&id=6f508e10&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f508e10"]])

export default __exports__